import _implicitStylesheets from "./contentText.css";
import _implicitScopedStylesheets from "./contentText.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="isloading${0}"${2}></div>`;
const stc0 = {
  key: 3
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {st: api_static_fragment, ncls: api_normalize_class_name, d: api_dynamic_text, t: api_text, s: api_slot, h: api_element} = $api;
  return [$cmp.isLoading ? api_static_fragment($fragment1, 1) : null, !$cmp.isLoading ? api_element("div", {
    className: api_normalize_class_name($cmp.styleClass),
    attrs: {
      "type-style": $cmp.typeStyle
    },
    key: 2
  }, [api_slot("", stc0, [api_text(api_dynamic_text($cmp.text))], $slotset)]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = [""];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5f38go9l5mb";
tmpl.legacyStylesheetToken = "undefined-_contentText";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
